import styled from 'styled-components';

import { space, media, rems } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';
import fonts from '../../ui/fonts';

const Forest = styled.div<{
  bg?: string;
}>`
  background: ${({ bg }) => `url(${bg}) 50% repeat-x`};
  height: ${rems(141)};
  margin: ${space(6)} 0 0;

  ${media.min('medium')`
    margin: ${space(8)} 0 0;
  `}
`;

const FooterStyled = styled.footer`
  ${fonts.bodySM};

  background: ${colors.neutral[900]};
  width: 100%; // Asegura que el footer ocupe todo el ancho disponible
  overflow-x: hidden; // Evita desbordamiento horizontal que causa espacios blancos
  a,
  a:hover,
  a:link,
  a:active,
  a:focus {
    font-weight: 400;
    text-decoration: none !important;
  }
`;

const WMap = styled.div`
  ${media.min('medium')`
    padding: 0 ${space(3)};
    margin: auto;
  `}

  ${media.between('medium', 1330)`
    padding: 0 ${space(3)};
  `}

  ${media.between(1330, 'xxlarge')`
    padding: 0;
  `};

  ${media.min('xxlarge')`
    padding: 0;
  `}
`;

const RRSS = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${space(6)} ${space(2)};

  .title {
    margin: 0 0 ${space(3)};
    color: ${colors.neutral[400]};
  }

  ${media.min('medium')`
    display: flex;
    justify-content: flex-end;
    text-align: left;
    flex-direction: row;
    padding-left: inherit;
    padding-right: inherit;

    .title {
      margin: 0 ${space(2)} 0 0;
    }
  `};
`;

const Foot = styled.div`
  background: ${colors.neutral[800]};
  padding: 0;
  width: 100%; // Asegura que el contenedor principal ocupe todo el ancho

  .wrapper {
    display: flex;
    flex-direction: column-reverse;
    padding: ${space(5)} ${space(2)} ${space(12)} ${space(2)}; // Añade padding lateral en móvil para evitar que el contenido toque los bordes
    width: 100%; // Asegura que el wrapper ocupe todo el ancho disponible
    box-sizing: border-box; // Incluye padding y border en el cálculo del ancho total
    ${media.min('medium')`
      padding: ${space(1)} 0; // padding del wrapper - solo vertical en desktop
      align-items: center;
      flex-direction: row-reverse;
      justify-content: space-between;
    `};
  }

  ${media.min('medium')`
    padding: ${space(3)} 0  ${space(3)} 0;
  `};
`;

const Language = styled.div`
  display: flex;
  margin: ${space(3)} 0 0 0;
  justify-content: center;
  width: 100%; // Asegura que el contenedor de idiomas ocupe todo el ancho disponible
  flex-wrap: wrap; // Permite que los idiomas se envuelvan a múltiples líneas en móvil

  a {
    text-transform: uppercase;
    color: ${colors.neutral[100]};
    &.active {
      color: ${colors.neutral[100]};
    }
  }
  ${media.min('medium')`
    margin-top: 0;
    justify-content: left;
    flex-wrap: nowrap; // En desktop, los idiomas se mantienen en una sola línea
    margin-left: ${space(3)}; // Añade margen izquierdo para separar del enlace de cookies
  `};
`;

const Links = styled.div`
  width: 100%; // Asegura que el contenedor de enlaces ocupe todo el ancho disponible
  
  .copyright {
    ${fonts.bodySM};
    color: ${colors.neutral[400]};
    margin: 0 0 ${space(2)};
    text-align: center;
    white-space: normal; // Permite que el copyright se envuelva en móvil para evitar que se corte
    ${media.min('medium')`
      margin: 0 ${space(2)} 0 0;
      white-space: nowrap; // En desktop mantiene el copyright en una sola línea
    `};
  }

  .menu-list {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%; // Asegura que la lista de menú ocupe todo el ancho disponible
    flex-wrap: wrap; // Permite que los elementos se envuelvan en móvil para evitar que se corten

    ${media.min('medium')`
      flex-direction: row;
      flex-wrap: nowrap; // Mantiene todos los elementos en una sola línea en desktop
    `};
  }

  .menu-item {
    white-space: normal; // Permite que el texto de cada enlace se envuelva en móvil
    ${media.min('medium')`
      white-space: nowrap; // En desktop mantiene el texto en una sola línea
    `};
    &:not(:last-child) {
      margin: 0 0 ${space(3)} 0;

      ${media.min('medium')`
        margin: 0 ${space(2)} 0 0; // Espaciado uniforme entre elementos en desktop
      `};
    }

    a {
      color: ${colors.neutral[100]};
      white-space: normal; // Permite que el texto del enlace se envuelva en móvil
      ${media.min('medium')`
        white-space: nowrap; // En desktop mantiene el texto en una sola línea
      `};

      &:hover,
      &:active {
        color: ${colors.neutral[100]};
      }
    }
  }

  ${media.min('medium')`
    align-items: center;
    display: flex;
    flex-wrap: nowrap; // Asegura que todo el contenedor se mantenga en una línea
  `};
`;

const CurrentCountry = styled.span`
  align-items: center;
  color: ${colors.neutral[100]};
  display: inline-flex;
  vertical-align: middle;

  svg {
    display: block;
    height: 14px;
    margin: 0 ${space()} 0 0;
    width: 14px;

    path {
      fill: currentColor;
    }
  }
`;

export { Forest, FooterStyled, Foot, Language, Links, RRSS, WMap, CurrentCountry };
